<template>
  <div class="company">
    <div class="boss" style="width: 90%;float: right;">
      <div class="Statistics">
        <ul>
          <li>数量统计</li>
          <li>
            <img src="../assets/gsbj.png" class="imgg" />
            <span class="span">公司总数</span>
            <span class="span1">{{count}}个</span>
          </li>
          <li>
            <img src="../assets/dsh.png" class="imgg" />
            <span class="spa">待审核</span>
            <span class="spa1">{{notCount}}个</span>
          </li>
          <li>
            <img src="../assets/ysh.png" class="imgg" />
            <span class="spa">已审核</span>
            <span class="spa1">{{yesCount}}个</span>
          </li>
        </ul>
      </div>
      <div class="bbt">
        <a
          class="s-bt"
          @click="selected()"
          :class="{active: active == 1}"
          style="margin-left: 40px;"
        >待审核</a>
        <a class="s-bt sss" @click="selected1()" :class="{active: active == 2}">已审核</a>
      </div>
      <div class="tab" v-show="dai">
        <el-table
          :data="tableData"
          style="width: 100%"
          :row-class-name="tableRowClassName"
          ref="table"
          align="left"
          :header-cell-style="{background:'#D0EAFF',color:'#333333',fontFamily:'MicrosoftYaHeiUI',fontSize:'16px',fontWeight:400}"
        >
          <el-table-column prop="orgName" label="医院名称" align="center"></el-table-column>
          <el-table-column prop="province" label="区域" align="center"></el-table-column>
          <el-table-column prop="businessLicenseImg" label="资格证书" align="center">
            <template slot-scope="scope">
              <el-popover placement="top" title trigger="click">
                <img :src="imgurl+imgs" class="imht1" />
                <img slot="reference" :src="imgurl+imgs" :alt="imgurl+imgs" class="imht" />
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column prop="email" label="备案邮箱" align="center"></el-table-column>
          <el-table-column prop="contactMobile" label="注册手机号" align="center"></el-table-column>
          <el-table-column prop="createTime" label="注册时间" align="center"></el-table-column>
          <el-table-column prop="state" label="审核" align="center">
            <template slot-scope="scope">
              <button
                @click="btn1(scope.row.userId)"
                style="width:60px;height:28px;border:none;cursor:pointer;background:rgba(0,153,68,1);border-radius:2px;line-height: 28px;font-size:14px;font-weight:400;color:rgba(255,255,255,1);"
              >通过</button>
              <button
                @click="btn2(scope.row.userId)"
                style="width:60px;height:28px;border:none;cursor:pointer;background:rgba(239,67,67,1);border-radius:2px;line-height: 28px;font-size:14px;font-weight:400;color:rgba(255,255,255,1);"
              >不通过</button>
            </template>
          </el-table-column>
        </el-table>
        <div class="Page">
          <div class="PageMain center" style="display: flex;justify-content: center;">
            <el-pagination
              background
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage1"
              :page-sizes="[100, 200, 300, 400]"
              :page-size="pageNum"
              layout="total, prev, pager, next, jumper"
              :total="totalNum"
            ></el-pagination>
            <!--<el-button type="primary" class="PageBtn" v-on:click="handleCurrentChange">确定</el-button>-->
          </div>
        </div>
      </div>
      <div class="tab" v-show="yi">
        <el-table
          :data="tableData1"
          style="width: 100%"
          :row-class-name="tableRowClassName"
          ref="table"
          align="left"
          :header-cell-style="{background:'#D0EAFF',color:'#333333',fontFamily:'MicrosoftYaHeiUI',fontSize:'16px',fontWeight:400}"
        >
          <el-table-column prop="orgName" label="医院名称" align="center"></el-table-column>
          <el-table-column prop="province" label="区域" align="center"></el-table-column>
          <el-table-column prop="businessLicenseImg" label="资格证书" align="center">
            <template slot-scope="scope">
              <el-popover placement="top" title trigger="click">
                <img :src="imgurl+imggs" class="imht1" />
                <img slot="reference" :src="imgurl+imggs" :alt="imgurl+imggs" class="imht" />
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column prop="email" label="备案邮箱" align="center"></el-table-column>
          <el-table-column prop="contactMobile" label="注册手机号" align="center"></el-table-column>
          <el-table-column prop="createTime" label="注册时间" align="center"></el-table-column>
          <el-table-column prop="state" label="审核结果" align="center">
            <template slot-scope="scope">
              <div
                :style="scope.row.state === '通过'?'color:#009944':'color:#EF4343'"
              >{{ scope.row.state }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="auditRemark" label="备注" align="center"></el-table-column>
        </el-table>
        <div class="Page">
          <div class="PageMain center" style="display: flex;justify-content: center;">
            <el-pagination
              background
              @size-change="handleSizeChange1"
              @current-change="handleCurrentChange1"
              :current-page="currentPage1"
              :page-sizes="[100, 200, 300, 400]"
              :page-size="pageNum"
              layout="total, prev, pager, next, jumper"
              :total="totalNum1"
            ></el-pagination>
            <!--<el-button type="primary" class="PageBtn" v-on:click="handleCurrentChange1">确定</el-button>-->
          </div>
        </div>
      </div>
    </div>
    <router-view />
  </div>
</template>

<script>
import Cookies from "js-cookie";
import { getDatacompany } from "@/request/api";
import { getDatacompany1 } from "@/request/api";
import { getDatacompany2 } from "@/request/api";
import { companystatua } from "@/request/api";
export default {
  name: "company",
  data() {
    return {
      active: "",
      tableData: [],
      imgurl: this.Common.imgurl,
      dai: true,
      yi: false,
      currentPage: 1,
      pageNum: 20,
      totalCount: 0,
      totalNum: "",
      totalNum1: "",
      currentPage1: 1,
      tableData: [],
      tableData1: [],
      count: 0,
      notCount: 0,
      yesCount: 0,
      id: [],
      imgs: "",
      imggs: "",
      status: 2,
      statusb: 3
    };
  },
  mounted() {
    this.getData();
    this.getDatacompany1();
    this.selected();
  },
  methods: {
    selected() {
      this.active = 1;
      this.getData();
      this.dai = true;
      this.yi = false;
    },
    //已审核
    selected1() {
      this.active = 2;
      this.yi = true;
      this.dai = false;
      let data = {
        pageSize: this.pageNum,
        pageIndex: this.currentPage1
      };
      getDatacompany2(data)
        .then(res => {
          console.log(res);
          this.tableData1 = res.data.data;
          this.totalNum1 = res.data.totalRows;
          var arr1 = res.data.data;
          for (var i = 0; i < arr1.length; i++) {
            console.log(arr1);
            this.imggs = arr1[i].businessLicenseImg;
            console.log(arr1[i].state);
            if (arr1[i].state == "2") {
              arr1[i].state = "通过";
            } else if (arr1[i].state == "3") {
              arr1[i].state = "不通过";
            }
            //						console.log(this.imggs)
          }
          //					console.log(this.count);
          //					if(res.data.code == "000000") {
          //					}
        })
        .catch(err => {
          console.log(err);
        });
    },
    btn1(id) {
      this.$confirm("此操作将为该公司通过审核, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          console.log(id);
          let data = {
            userId: id,
            state: this.status
          };
          companystatua(data)
            .then(res => {
              this.getData();
              this.getDatacompany1();
              console.log(res);
              this.$message({
                type: "success",
                message: "审核通过!"
              });
            })
            .catch(err => {
              console.log(err);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消审核"
          });
        });
    },
    btn2(id) {
      this.$confirm("该公司将不通过审核, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          console.log(id);
          let data = {
            userId: id,
            state: this.statusb
          };
          companystatua(data)
            .then(res => {
              this.getData();
              this.getDatacompany1();
              console.log(res);
              this.$message({
                type: "success",
                message: "操作成功!"
              });
            })
            .catch(err => {
              console.log(err);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作"
          });
        });
    },
    getData() {
      let data = {
        pageSize: this.pageNum,
        pageIndex: this.currentPage
      };
      getDatacompany(data)
        .then(res => {
          this.tableData = res.data.data;
          this.totalNum = res.data.totalRows;
          var arr = res.data.data;
          console.log(arr);
          for (var i = 0; i < arr.length; i++) {
            this.id = arr[i].userId;
            console.log(this.id);
            this.imgs = arr[i].businessLicenseImg;
            //						this.status = arr[i].state;
          }
          console.log(res);
        })
        .catch(err => {});
    },
    getDatacompany1() {
      let token = Cookies.get("token");
      console.log(token);
      let data = {
        //				pageIndex: this.pageNum,
        //				pageSize: this.currentPage,
      };
      getDatacompany1(data)
        .then(res => {
          console.log(res.data.data);
          this.count = res.data.data.count;
          this.notCount = res.data.data.notCount;
          this.yesCount = res.data.data.yesCount;

          //					console.log(this.count);
          //					if(res.data.code == "000000") {
          //					}
        })
        .catch(err => {
          console.log(err);
        });
    },
    tabRowClassName({ row, rowIndex }) {
      let index = rowIndex + 1;
      if (index % 2 == 0) {
        return "warning-row";
      }
    },
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex === 1) {
        return "warning-row";
      } else if (rowIndex === 3) {
        return "success-row";
      }
      return "";
    },
    handleSizeChange(val) {
      this.pageNum = val;
      console.log(this.pageNum);
      this.getData();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      console.log(this.currentPage);
      this.getData();
    },
    handleSizeChange1(val) {
      this.pageNum = val;
      console.log(this.pageNum);
      this.selected1();
    },
    handleCurrentChange1(val) {
      this.currentPage1 = val;
      console.log(this.currentPage1);
      this.selected1();
    }
  }
};
</script>

<style scoped>
.imht {
  width: 130px;
  height: 60px;
}
.imht1 {
  width: 800px;
  height: 500px;
}
.ss {
  display: block;
  float: left;
  /*margin-left:50px;*/
  cursor: pointer;
  height: 60px;
  color: rgba(54, 114, 191, 1);
  border-bottom: 2px solid rgba(54, 114, 191, 1);
  font-size: 16px;
  font-weight: bold;
}
.ss1 {
  margin-left: 50px;
  cursor: pointer;
}
.s-bt {
  display: block;
  float: left;
  margin-left: 8px;
  cursor: pointer;
}
.sss {
  margin-left: 50px;
}
.active {
  height: 60px;
  color: rgba(54, 114, 191, 1);
  border-bottom: 2px solid rgba(54, 114, 191, 1);
  font-size: 16px;
  font-weight: bold;
}
.el-table .warning-row {
  background: #f6fbff;
}
.Statistics {
  widows: 80%;
  height: 140px;
  background: rgba(255, 255, 255, 1);
}
ul li {
  display: flex;
  float: left;
  line-height: 140px;
  font-size: 16px;
  font-weight: bold;
  padding-left: 40px;
  /*padding-right: 50px;*/
  color: rgba(54, 114, 191, 1);
}
ul li + li {
  width: 210px;
  height: 140px;
  /*float: left;*/
  margin-left: 50px;
  line-height: 140px;
}
.span {
  position: absolute;
  /*left: -190px;*/
  top: 55px;
  padding-left: 20px;
  /*padding-top: -20px;*/
  font-size: 16px;
  font-weight: 400;
  color: rgba(245, 245, 245, 1);
}
.span1 {
  position: absolute;
  /*left: -260px;*/
  top: 100px;
  font-size: 24px;
  padding-left: 20px;
  font-weight: bold;
  color: rgba(255, 255, 255, 1);
}
.spa {
  position: absolute;
  /*left: -190px;*/
  top: 55px;
  padding-left: 20px;
  font-size: 16px;
  font-weight: 400;
  color: rgba(245, 245, 245, 1);
}
.spa1 {
  position: absolute;
  /*left: -240px;*/
  top: 100px;
  padding-left: 20px;
  font-size: 24px;
  font-weight: bold;
  color: rgba(255, 255, 255, 1);
}
.imgg {
  width: 205px;
  height: 109px;
  /*line-height: 150px;*/
  /*margin-top: 20px;*/
  position: relative;
  top: 18px;
}
.bbt {
  width: 100%;
  height: 60px;
  float: left;
  line-height: 60px;
  margin-top: 15px;
  margin-bottom: 20px;
  background: rgba(255, 255, 255, 1);
  /*background: #EEF2F6;*/
  border-radius: 4px;
}
.Page {
  margin-top: 20px;
}
.el-pagination {
  margin-top: 0px;
  margin-bottom: 0px;
}
</style>


// WEBPACK FOOTER //
// src/administrators/companyaudit.vue